import {
  DioboxEvent, EventCounts, Website, Translations,
} from "sharedTypes"
import { EventUserRole } from "services/permissions"
import { BadgeQRFormat } from "sharedTypes/badge"

export const QR_MOCK_DATA = {
  [BadgeQRFormat.GUEST_ID]: "https://diobox.com",
  [BadgeQRFormat.VCARD]: `BEGIN:VCARD
    VERSION:3.0
    N:Placeholder;Mr.
    EMAIL:placeholder@diobox.com
    TEL;TYPE=phone:1233211234
    TITLE:Badge Builder
    ORG:Diobox
    X-DIOBOXGUUID:6b7608aa-fb00-4680-849c-4807e9ef4303
    REV:2022-05-09T20:56:01Z
    END:VCARD`,
} as const

export const SAMPLE_EVENT_DATA: DioboxEvent = {
  id: "sample-event-1",
  addressLine1: "123 Conference St",
  addressLine2: "Suite 456",
  checkInLocations: [],
  city: "San Francisco",
  country: "US",
  counts: {
    guests: 0,
    confirmedGuests: 0,
    waitlistedGuests: 0,
    declinedGuests: 0,
    unconfirmedGuests: 0,
    arrivedGuests: 0,
    unarrivedGuests: 0,
    seatedGuests: 0,
    unseatedGuests: 0,
    tables: 0,
  } as EventCounts,
  currency: "USD",
  customDomain: null,
  deferredTicketAssignmentEnabled: false,
  emailNotificationsCustomMessage: null,
  publicEventTitle: "Event Name",
  emailNotificationsReplyTo: "noreply@example.com",
  emailNotificationsSenderMailbox: null,
  emailNotificationsSenderName: "Event Organizer",
  emailNotificationsUserIds: [],
  endDate: null,
  eventGroups: [],
  segments: [],
  users: [],
  guestCount: 0,
  maxTeamSize: 1,
  maxTables: null,
  nonTicketedGuestLimit: null,
  capacity: null,
  agendaEnabled: false,
  checkInLocationsEnabled: false,
  privateEmailsEnabled: false,
  publicEmailsEnabled: false,
  enhanceEnabled: false,
  startDate: new Date().toISOString(),
  state: "CA",
  tables: [],
  timezone: "America/Los_Angeles",
  title: "Event Name",
  venue: "Conference Center",
  website: {
    content: "",
    coverImageUrl: "",
    dateEnabled: false,
    dateHeader: "",
    speakersEnabled: false,
    speakersHeader: "",
    agendaEnabled: false,
    agendaHeader: "",
    dateLine1: "",
    dateLine2: "",
    links: [],
    linksEnabled: false,
    locationEnabled: false,
    locationVenue: "",
    locationLine1: "",
    locationLine2: "",
    locationLine3: "",
    mapEnabled: false,
    published: false,
    previewToken: "",
    templateId: null,
    title: "",
    urlPath: "",
    url: "https://d.io/sample-event/w",
    previewUrl: "https://d.io/sample-event/w",
    viewsCount: 0,
    speakers: [],
    agendaRows: [],
    rsvpHeaderEventLogoUrl: "",
    rsvpHeaderTitle: "",
    rsvpHeaderLine1: "",
    rsvpHeaderLine2: "",
    rsvpProfileAddressEnabled: false,
    rsvpProfileAddressRequired: false,
    rsvpProfileBirthDateEnabled: false,
    rsvpProfileBirthDateRequired: false,
    rsvpProfileCompanyEnabled: false,
    rsvpProfileCompanyRequired: false,
    rsvpProfileEmailEnabled: false,
    rsvpProfileEmailRequired: false,
    rsvpProfileFirstNameEnabled: false,
    rsvpProfileFirstNameRequired: false,
    rsvpProfileGenderEnabled: false,
    rsvpProfileGenderRequired: false,
    rsvpProfileLastNameEnabled: false,
    rsvpProfileLastNameRequired: false,
    rsvpProfilePhoneEnabled: false,
    rsvpProfilePhoneRequired: false,
    rsvpProfileTitleEnabled: false,
    rsvpProfileTitleRequired: false,
    rsvpProfileCityEnabled: false,
    rsvpProfileCityRequired: false,
    rsvpProfileCountryEnabled: false,
    rsvpProfileCountryRequired: false,
    rsvpProfilePostalCodeEnabled: false,
    rsvpProfilePostalCodeRequired: false,
    rsvpProfileStateEnabled: false,
    rsvpProfileStateRequired: false,
    rsvpButtonColor: "",
    actionEnabled: false,
    actionBehavior: "tickets" as const,
    actionText: "",
    ticketHeaderEventLogoUrl: "",
    ticketHeaderTitle: "",
    ticketHeaderLine1: "",
    ticketHeaderLine2: "",
    waitlistHeaderEventLogoUrl: "",
    waitlistHeaderTitle: "",
    waitlistHeaderLine1: "",
    waitlistHeaderLine2: "",
    websiteData: {
      blocks: [],
    },
  } as Website,
  zipcode: "94105",
  currentUserRole: EventUserRole.EventAdmin,
  whiteLabel: false,
  notificationsEnabled: false,
  badgePrintingEnabled: true,
  segmentsEnabled: false,
  qrCodesEnabled: true,
  kioskModeEnabled: true,
  expiringQrCodes: false,
  guestGroupsEnabled: false,
  ccEmailsEnabled: false,
  sendConfirmationEmails: true,
  translations: {
    addressLine1: "",
    addressLine2: "",
    city: "",
    company: "",
    confirmed: "",
    continue: "",
    country: "",
    declined: "",
    editProfile: "",
    editProfileHeader: "",
    emailAddress: "",
    emailNotifications: "",
    emailSubscription: "",
    firstName: "",
    fullName: "",
    lastName: "",
    payment: "",
    phone: "",
    postalCode: "",
    qrCodeForCheckIn: "",
    registerGuestsNow: "",
    capacityReachedMessage: "",
    registrationClosingMessage: "",
    registrationEditMessage: "",
    registrationSubmitButton: "",
    registrationSuccessMessage: "",
    rsvpClosingMessage: "",
    rsvpConfirm: "",
    rsvpDecline: "",
    rsvpEditMessage: "",
    rsvpPlusOneLabel: "",
    rsvpPlusOneNo: "",
    rsvpPlusOneYes: "",
    rsvpSubmitButton: "",
    rsvpSuccessMessage: "",
    save: "",
    state: "",
    ticketClosingMessage: "",
    ticketEditMessage: "",
    ticketSubmitButton: "",
    ticketSuccessMessage: "",
    title: "",
    unconfirmed: "",
    uploadPhoto: "",
    viewMap: "",
    whatsappOptInDisclaimer: "",
    waitlistClosingMessage: "",
    waitlistEditMessage: "",
    waitlistSubmitButton: "",
    waitlistSuccessMessage: "",
    waitlisted: "",
    yourInformation: "",
  } as Translations,
  portalBackgroundColor: "#ffffff",
  portalDateTimeLocation: "Conference Center, San Francisco",
  portalEventImageUrl: null,
  portalEventVideoUrl: null,
  portalLogoUrl: null,
  portalMapUrl: "",
  portalPrimaryColor: "#3182ce",
  portalShowEventImage: false,
  portalShowEventVideo: false,
  portalShowLogo: false,
  portalShowMap: false,
  portalTopNavBackgroundColor: "#3182ce",
  portalTopNavTextColor: "#ffffff",
  externalId: "ext-event-123",
  slug: "sample-event",
  slugClaimed: false,
  slugChangedAt: null,
  slugRenameAllowedAt: null,
  rootTarget: null,
  rootFormId: null,
  vanityUrlsEnabled: false,
  urls: {
    root: "https://d.io/sample-event",
    site: "https://d.io/sample-event/w",
    sitePreview: "https://d.io/sample-event/w",
    portal: "https://d.io/sample-event/p",
    entry: "https://d.io/sample-event/p",
  },
  portalEventImageScale: 1,
  portalPageHeader: "Welcome",
  portalShowPageHeader: true,
  portalCaptchaEnabled: false,
  includePassbook: false,
  includeQrCode: true,
  stripeAccountId: null,
  leadRetrievalLicenseFee: "0",
  leadRetrievalEnabled: false,
  textsEnabled: false,
  passBuilderEnabled: false,
  customLanguageTemplatesEnabled: false,
  zapierEnabled: false,
  googleAnalyticsMeasurementId: null,
  attachIcs: false,
  language: "en",
  portalShowEventTitle: true,
  kioskAccentColor: null,
  kioskLogoUrl: null,
  kioskBackgroundImageUrl: null,
  kioskShowEventTitle: true,
  kioskShowGuestPhoto: true,
  kioskShowGuestSeat: true,
  kioskScanQrCodeEnabled: true,
  kioskWalkInRegistrationEnabled: false,
  kioskWalkInRegistrationForm: null,
  useLegacyIosBadges: false,
  autoOptInEnabled: true,
  smsFallbackEnabled: true,
  defaultOptInTextId: null,
  defaultLanguageTemplateId: null,
}
